import React from 'react';
import { ResetPasswordFormContainer, FormButtonContainer } from './style';
import { AuthenticationInput } from './AuthenticationInput';
import { SemiTransparentButton } from '../../../Layouts';

export const UpdatePasswordForm = ({
    password,
    passwordConfirmation,
    handleChange,
    handleSubmit,
    isSubmitButtonDisabled,
    validationErrors,
}) => {
    return (
        <ResetPasswordFormContainer onSubmit={handleSubmit}>
            <AuthenticationInput
                value={password}
                type={'password'}
                onChange={handleChange}
                name={'password'}
                placeholder={'New password'}
                errorMessage={validationErrors.password}
            />

            <AuthenticationInput
                value={passwordConfirmation}
                type={'password'}
                onChange={handleChange}
                name={'passwordConfirmation'}
                placeholder={'Confirm password'}
                errorMessage={validationErrors.passwordConfirmation}
            />

            <FormButtonContainer>
                <SemiTransparentButton disabled={isSubmitButtonDisabled} type={'submit'}>
                    Update password
                </SemiTransparentButton>
            </FormButtonContainer>
        </ResetPasswordFormContainer>
    );
};

UpdatePasswordForm.defaultProps = {
    validationErrors: {},
};



// WEBPACK FOOTER //
// ./src/UI/Components/forms/AuthenticationForms/UpdatePassword.js